import { NgModule } from '@angular/core';
import { RouterModule, Routes, RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

import { HomeComponent } from './main/pages/home/home.component';
import { DetailPageComponent } from './main/pages/detail/detail.component';
import { ShoppingCartPageComponent } from './main/pages/cart/shopping-cart/shopping-cart.component';
import { CheckoutComponent } from './main/pages/cart/checkout/checkout.component';
import { ThankYouComponent } from './main/pages/thankyou/thankyou.component';
import { NotFoundComponent } from './main/pages/notfound/notfound.component';
import { AppResolver } from './main/services/app.resolver';
import { CategoryPageComponent } from './main/pages/category/category.component';
import { ListProductsPageComponent } from './main/pages/list-products/list-products.page';

const resolver = {appData: AppResolver};

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
	shouldDetach(route: ActivatedRouteSnapshot): boolean { return false; }
	store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}
	shouldAttach(route: ActivatedRouteSnapshot): boolean { return false; }
	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle { return null; }
	shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		return curr.routeConfig === null && future.routeConfig === null;
	}
}

const routes: Routes = [
	{
		path: 'd/:domainId',
		resolve: resolver,
		children: [
			{ path: 'home', component: HomeComponent },
			{ path: 'detail/:datasetCode/:recordId', component: DetailPageComponent },
			{ path: 'detail/:datasetCode/:recordId/:lang', component: DetailPageComponent },
			{ path: 'category/:recordId', component: CategoryPageComponent },
			{ path: 'list', component: ListProductsPageComponent},
			{ path: 'cart', component: ShoppingCartPageComponent },
			{ path: 'checkout', component: CheckoutComponent },
			{ path: 'thankyou/:status', component: ThankYouComponent },
		]
	},
	{ path: 'notfound', component: NotFoundComponent, resolve: resolver },
	{ path: '**', redirectTo: '/notfound' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { 
		enableTracing: false, 
		onSameUrlNavigation: 'ignore' 
	})],
	providers: [{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }],
	exports: [RouterModule]
})
export class AppRoutingModule { }
